<template>
  <x-page title="店铺页面" :loading="loading">
    <template
      #header="{ headerParallaxRate, handleBackClick, handleShareClick }"
    >
      <div
        :class="_.header"
        :style="{
          backgroundColor:
            headerParallaxRate === 0
              ? 'transparent'
              : `rgba(91, 0, 201, ${headerParallaxRate})`,
        }"
      >
        <!-- 返回 -->
        <x-icon name="back" :class="_.back" @click="handleBackClick" />

        <div :class="_.search">
          <img src="../order/images/center/搜索.png" :class="_.icon" />
          <x-plain-search
            v-model="keyWordTemp"
            :class="_.input"
            placeholder="关键字搜索"
            @search="search"
            @blur="search"
          />
        </div>

        <!-- 分享 -->
        <img
          v-if="false"
          :class="_.share"
          src="./images/share.png"
          alt=""
          @click="handleShareClick"
        />
      </div>
    </template>
    <template v-if="!loading">
      <x-waterfall
        ref="waterfall"
        :key="waterfallKey"
        :class="_.waterfall"
        :load="handleLoad"
      >
        <template #default="{ data }">
          <div
            v-for="(item, index) in data"
            :key="index"
            :class="_.item"
            @click="goDetail(item)"
          >
            <div :class="_.top">
              <div :class="_.img" :src="item.childCommodityPic">
                <img
                  :src="item.childCommodityPic || $route.query.commodityPic"
                />
                <div :class="_.stock">库存：{{ item.cutStock }}</div>
              </div>
              <div :class="_.info">
                <p :class="[_.name, _._ellipsisFlex]">
                  {{ item.merchantName }}
                </p>
                <p v-if="item.commodityType !== 1001" :class="_.tel">
                  联系电话：<br />
                  {{ item.merchantPhone }}
                </p>
                <p v-if="item.commodityType === 1001" :class="_.tel">
                  {{ item.commodityName }}
                </p>
              </div>
              <button>
                {{ item.commodityType === 1001 ? '兑换' : '本店兑换'
                }}<van-icon name="arrow"></van-icon>
              </button>
            </div>
            <div
              v-if="item.merchantAddress"
              :class="_.bottom"
              @click.stop="goMap(item)"
            >
              <div :class="_.left">
                <div :class="_.icon">
                  <van-icon name="location-o"></van-icon>
                </div>

                <span :class="_.address"> {{ item.merchantAddress }}</span>
              </div>

              <span v-if="item.merchantDistance !== '未知'" :class="_.right">{{
                item.merchantDistance
              }}</span>
            </div>
          </div>
        </template>
      </x-waterfall>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { apiCommodityVirtualExchangeFindExchangeStoreList } from '@/api'
  import { navigateTo } from '@/router'
  import { openMap } from '@/utils'
  import { Track } from '@/utils/Track'
  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '兑换店铺页',
      })),
    ],
    data() {
      return {
        waterfallKey: 'exchangeStoreList',
        longitude: '',
        latitude: '',
        keyWordTemp: '',
        keyWord: '',
        loading: false,
      }
    },
    methods: {
      search() {
        this.keyWord = this.keyWordTemp
      },
      async handleLoad({ pageNumber }) {
        const exchangeCommodityType = this.$route.query.exchangeCommodityType
        const queryId = this.$route.query.id
        if (!this.longitude && exchangeCommodityType !== '1001') {
          const { latitude, longitude } = await this.$dcb.getLocation({
            mustBeAuth: true,
          })
          if (
            latitude < 1 ||
            !latitude ||
            latitude === 'NaN' ||
            latitude === 'undefined'
          ) {
            this.$toast('请先打开手机定位')
          } else {
            this.longitude = longitude
            this.latitude = latitude
          }
        }
        return apiCommodityVirtualExchangeFindExchangeStoreList({
          id: queryId,
          keyWord: this.keyWord,
          pageIndex: pageNumber,
          longitude: this.longitude,
          latitude: this.latitude,
          pageSize: 10,
        }).then(res => {
          return res
        })
      },
      async goDetail(item) {
        switch (item.commodityType) {
          case 0:
            this.$router.push({
              name: 'GoodsIndex',
              query: {
                id: item.childCommodityId,
                exchangeCommodityId: this.$route.query.exchangeCommodityId,
                type: 'exchange',
                track_from: '兑换商品',
                parentOrderNo: this.$route.query.orderNo,
                parentCommodityId: this.$route.query.parentCommodityId,
                skuId: item.skuId,
              },
            })
            break
          case 1:
            this.$router.push({
              name: 'BookGoodsIndex',
              query: {
                goodsId: item.childCommodityId,
                exchangeCommodityId: this.$route.query.exchangeCommodityId,
                type: 'exchange',
                track_from: '兑换商品',
                parentOrderNo: this.$route.query.orderNo,
                parentCommodityId: this.$route.query.parentCommodityId,
                skuId: item.skuId,
              },
            })
            break
          case 4:
            this.$router.push({
              name: 'TravelGoodsIndex',
              query: {
                goodsId: item.childCommodityId,
                exchangeCommodityId: this.$route.query.exchangeCommodityId,
                type: 'exchange',
                track_from: '兑换商品',
                parentOrderNo: this.$route.query.orderNo,
                parentCommodityId: this.$route.query.parentCommodityId,
                skuId: item.skuId,
              },
            })
            break
          case 1001:
            navigateTo('ExchangeInfo', {
              commodityId: item.childCommodityId,
              exchangeCommodityId: this.$route.query.exchangeCommodityId,
              parentOrderNo: this.$route.query.orderNo,
            })

            break
          default:
            break
        }
      },
      goMap(item) {
        if (!item.latitude) {
          return
        }
        openMap({
          name: item.merchantName,
          latitude: +item.latitude,
          longitude: +item.longitude,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    box-sizing: border-box;
    // color: white;

    .back {
      flex-shrink: 0;
      font-size: 16px;

      &:active {
        opacity: 0.8;
      }
    }

    .search {
      margin: 0 13px;
      margin-right: 0;
      flex-grow: 1;
      display: flex;
      align-items: center;
      height: 32px;
      background: #f5f5f5;
      border-radius: 19px;
      padding: 0 16px;

      .icon {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
      }

      .input {
        margin-left: 12px;
        font-size: 14px;
        color: #333;

        &::placeholder {
          color: #aaa;
        }
      }
    }

    .share {
      width: 22px;
      height: 22px;
    }
  }
  .waterfall {
    padding: 12px;
    .item {
      margin-bottom: 12px;
      background: #fff;
      padding: 12px;
      border-radius: 12px;
      .top {
        display: flex;
        align-items: center;
        width: 100%;
        .img {
          position: relative;
          border-radius: 8px;
          border: 1px solid #f7f7f7;
          overflow: hidden;
          width: 112px;
          height: 80px;
          margin-right: 13px;
          img {
            width: 100%;
            object-fit: cover;
          }
          .stock {
            position: absolute;
            top: 0;
            left: 0;
            width: 60px;
            height: 16px;
            background: conic-gradient(
              from 47.33972709473454deg at -76.82304382324219% -80.82486987113953%,
              #ffc222 0%,
              #ff111c 100%
            );
            border-radius: 8px 0px 8px 0px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 11px;
            color: #ffffff;
            line-height: 16px;
            text-align: center;
            font-style: normal;
          }
        }
        .info {
          flex: 1;
          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #222222;
            line-height: 18px;
            text-align: left;
            font-style: normal;
          }
          .tel {
            margin-top: 4px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 15px;
            text-align: left;
            font-style: normal;
          }
        }
        button {
          width: 90px;
          height: 26px;
          border-radius: 16px;
          border: 1px solid #ff202a;
          background: #ffffff;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #ff202a;
          line-height: 20px;
          text-align: center;
          font-style: normal;
          padding-left: 7px;
        }
      }
      .bottom {
        margin-top: 13px;
        padding-top: 13px;
        display: flex;
        position: relative;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 12px;
        text-align: left;
        font-style: normal;
        &::before {
          top: 0;
          background: #eeeeee;
          position: absolute;
          content: '';
          display: block;
          width: 327px;
          height: 1px;
          transform: scaleY(0.5);
        }
        .left {
          display: flex;
          flex: 1;
          text-align: left;
          margin-right: 12px;
        }
        .icon {
          margin-right: 3px;
        }
      }
    }
  }
</style>
